<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div v-if="showBuyLeads" class="row pt-2 pt-sm-4">
          <b-col class="col col-12 d-inline-flex align-items-center justify-content-between">
            <h2 class="h3 mb-0">
              {{ $t('Latest Leads') }}
            </h2>
            <router-link v-if="!isMobile" class="btn btn-sm btn-outline-secondary" :to="{name:'buy-leads'}">
              {{ $t('Go To Buy Leads') }}
            </router-link>
          </b-col>
        </div>
        <hr :class="{'my-2': isMobile}">
        <div class="row">
          <div class="col-12 d-flex flex-column">
            <marketplace-leads-list-lite :display-rows="buyLeadsRows" />
            <b-card no-body :header-class="'d-none'">
              <b-card-footer :footer-class="'d-flex bg-transparent justify-content-center'">
                <router-link class="btn btn-sm btn-outline-secondary mr-2" :to="{name:'my-leads'}">
                  {{ $t('My Leads') }}
                </router-link>
                <router-link v-if="showBuyLeads" class="btn btn-sm btn-outline-secondary" :to="{name:'buy-leads'}">
                  {{ $t('Buy Leads') }}
                </router-link>
              </b-card-footer>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketplaceLeadsListLite from "@/components/list/MarketplaceLeadsListLite";
import userDevice from "@/imports/mixins/userDevice";
import companyAccount from "@/imports/mixins/companyAccount";
export default {
  name: 'HomepageMobileBuyLeads',
  components: {
    MarketplaceLeadsListLite,
  },
  mixins: [userDevice, companyAccount],
  props: ["buyLeadsRows"],
}
</script>
